import React, {Component} from 'react';
import {APIClient} from "../../utils/APIClient";
import {SubmitButton} from "../buttons/SubmitButton";
import {Spinner} from "../Spinner";
import {API_URL} from "../../settings/local_settings";
import {BusinessUnitHeader} from "./BusinessUnitHeader";
import {LayoutSidebar} from "../../Layout";
import {AlertsConfiguration} from "../common/AlertsConfiguration";
import {BusinessUnitTabs} from "./BusinessUnitTabs";
import {Switch} from "../buttons/Swtich";
import {SaveBar} from "../elements/SaveBar";
import {withRouterParams} from "../../utils/withRouterParams";
import {LineAlertRecipients} from "../alerts/LineAlertRecipients";
import { withTranslation } from 'react-i18next';

class BusinessUnitAlertsConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            indicators: null,
            agencyFlexIndicators: null,
            agencyEcommerceFixedFlexIndicators: null,
            savingChanges: false,
            useAgencyConfiguration: null,
            hasChanges: false,
            // El cliente de la línea: lo trae el encabezado (`business-unit/<id>/edit`) y lo necesita
            // «Quién recibe», que es por cliente.
            clientId: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleIndicatorChange = this.handleIndicatorChange.bind(this);
        this.handleToggleUseAgencyConfig = this.handleToggleUseAgencyConfig.bind(this);
        this.handleGoToTabUrl = this.handleGoToTabUrl.bind(this);
        this.handleBusinessUnitLoaded = this.handleBusinessUnitLoaded.bind(this);
    }

    handleBusinessUnitLoaded(data) {
        this.setState({clientId: data.client_id ?? null});
    }

    handleGoToTabUrl(url) {
        this.props.history.push(url);
    }

    componentDidMount() {
        this.getInitialAlertConfiguration();
    }

    configureAlertsUrl() {
        return `${API_URL}business-unit/${this.props.match.params.id}/alerts-configuration`;
    }

    // API

    getInitialAlertConfiguration() {
        new APIClient(this.configureAlertsUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                const dataForForm = this.prepareDataForForm(data.data);
                this.setState(dataForForm);
            }
        });
    }

    prepareDataForForm(data) {
        let result = {};
        let useAgencyConfiguration = true;
        Object.keys(data["configuration_per_indicator"]).forEach(indicatorName => {
            let indicator = data["configuration_per_indicator"][indicatorName];
            result[indicatorName] = {
                is_active: indicator.is_active,
                sensitivity_values: indicator.sensitivity_values.map((sensitivity_value) => {
                    return {
                        ...sensitivity_value,
                        value: Math.round(sensitivity_value.value * 100)
                    }
                })
            };
            //If at least one is active, assume all active
            if (indicator.is_configuration_active) {
                useAgencyConfiguration = false;
            }
        });
        return {
            indicators: result,
            agencyFlexIndicators: data["agency_flex_indicators"],
            agencyEcommerceFixedFlexIndicators: data["agency_ecommerce_fixed_flex_indicators"],
            useAgencyConfiguration: useAgencyConfiguration
        };
    }

    prepareDataForSubmit() {
        let result = {};
        Object.keys(this.state.indicators).forEach(indicatorName => {
            const indicator = this.state.indicators[indicatorName];
            result[indicatorName] = {
                is_configuration_active: !this.state.useAgencyConfiguration,
                is_active: indicator.is_active,
                sensitivity_values: indicator.sensitivity_values.map((sensitivity_value) => {
                    return {
                        ...sensitivity_value,
                        value: sensitivity_value.value / 100
                    }
                }),
            }
        });
        return result;
    }

    // handlers

    handleSubmit() {
        const { t } = this.props;
        this.setState({savingChanges: true});

        const data = this.prepareDataForSubmit();
        new APIClient(this.configureAlertsUrl()).call('PUT', data).then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.setState({savingChanges: false, hasChanges: false});
                alert(t('business_unit_alerts.changes_saved'));
            }
        });
    }

    handleIndicatorChange(indicators) {
        this.setState({
            indicators: indicators,
            hasChanges: true
        });
    }

    handleToggleUseAgencyConfig(event) {
        const isOn = !event.target.checked;
        this.setState({
            useAgencyConfiguration: isOn,
            hasChanges: true
        });
    }

    // rendering

    renderSaveButton() {
        const { t } = this.props;
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={t('save_button')}/>;
        }
    }

    renderUseAgencyConfigurationSwitch() {
        if (this.state.useAgencyConfiguration !== null) {
            return (
                <Switch onChange={this.handleToggleUseAgencyConfig}
                        checked={!this.state.useAgencyConfiguration}/>
            );
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive small"/>
                </div>
            );
        }
    }

    renderUseAgencyConfigurationBox() {
        const { t } = this.props;
        return (
            <div className="form-row switch-input">
                <div className="label-with-explanation">
                    <label>{t('business_unit_alerts.use_special_config')}</label>
                    <p>{t('business_unit_alerts.special_config_explanation')}</p>
                </div>
                {this.renderUseAgencyConfigurationSwitch()}
            </div>
        )
    }

    renderAlertsConfiguration() {
        if(!this.state.useAgencyConfiguration) {
            return <AlertsConfiguration indicators={this.state.indicators}
                                        agencyFlexIndicators={this.state.agencyFlexIndicators}
                                        agencyEcommerceFixedFlexIndicators={this.state.agencyEcommerceFixedFlexIndicators}
                                        onIndicatorsChange={this.handleIndicatorChange} />
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <BusinessUnitHeader businessUnitId={this.props.match.params.id}
                                        onLoaded={this.handleBusinessUnitLoaded}/>
                    <BusinessUnitTabs
                        businessUnitId={this.props.match.params.id}
                        activeTab="-last"
                        changesMade={this.state.hasChanges}
                        goToTabUrl={this.handleGoToTabUrl}
                    />
                    <div className="section-body h-items">
                        <div className="section-body-item -wider box">
                            <header className="box-header">
                                <h2 className="box-title">{t('business_unit_alerts.title')}</h2>
                            </header>
                            <div className="form-row">
                                {this.renderUseAgencyConfigurationBox()}
                            </div>
                            {this.renderAlertsConfiguration()}
                            <LineAlertRecipients clientId={this.state.clientId}/>
                        </div>
                        <SaveBar
                            onClick={this.handleSubmit}
                            isSaving={this.state.savingChanges}
                            hasChanges={this.state.hasChanges}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

export default withRouterParams(withTranslation()(BusinessUnitAlertsConfiguration));
